import { ILibraryFormSubmissionResponse } from '../api/types';

export class LibraryFormSubmission implements ILibraryFormSubmissionResponse {
  readonly id: number;
  readonly dossierRelationId: number;
  readonly libraryItemId: number;
  readonly libraryId: number;
  readonly formId: number;
  readonly name: string;
  readonly raw: any[];
  readonly html: string;
  readonly createdAt: Date;

  constructor({ id, dossierRelationId, libraryItemId, libraryId, formId, name, raw, html, createdAt }: ILibraryFormSubmissionResponse) {
    this.id = id;
    this.dossierRelationId = dossierRelationId;
    this.libraryItemId = libraryItemId;
    this.libraryId = libraryId;
    this.formId = formId;
    this.name = name;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const rawCopy = typeof raw === 'string' ? JSON.parse(raw) : JSON.parse(JSON.stringify(raw));
    if (!Array.isArray(rawCopy)) {
      throw new Error('Raw is not a array');
    }
    this.raw = rawCopy;
    this.html = html;
    this.createdAt = new Date(createdAt);
  }
}
